<div class="countdown">
  Auction ends in {{ countdown }}
</div>
